var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-fcf1d135-0471-4975-a13f-4a8ea9f9faca",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-3c955ade-df95-4786-a3af-c413e1667009 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-3c955ade-df95-4786-a3af-c413e1667009",
    d: "M16,20.34c-.28,0-.56-.12-.75-.33l-5.97-6.68c-.37-.41-.33-1.04.08-1.41.41-.37,1.04-.33,1.41.08l5.23,5.84,5.23-5.84c.37-.41,1-.45,1.41-.08.41.37.45,1,.08,1.41l-5.97,6.68c-.19.21-.46.33-.75.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.5f9a37ef8b12e7d9cee6eeee936f4893.svg";
export { ForwardRef as ReactComponent };